import type { ExecutionLogEntry } from '@/api/cockpit';

export function executionLogToneClass(entry: ExecutionLogEntry): string {
  if (entry.reason) {
    const normalized = entry.toState.toLowerCase();
    if (normalized.includes('failed') || normalized.includes('error')) {
      return 'border-l-red-600';
    }
    return 'border-l-yellow-500';
  }
  return 'border-l-emerald-600';
}
